<template>
  <div class="trending-action__single trending-action__single--v2">
    <div class="nftmax-trendmeta">
      <div class="nftmax-trendmeta__main">
        <div class="nftmax-trendmeta__author">
          <!-- <div class="nftmax-trendmeta__img">
            <img
              :src="require(`../../../assets/img/market-author-1.png`)"
              alt="#"
            />
          </div> -->
          <div class="nftmax-trendmeta__content">
            <span class="nftmax-trendmeta__small">Created</span>
            <h4 class="nftmax-trendmeta__title">
              {{ format(datas.createdAt) }}
            </h4>
          </div>
        </div>
        <div v-if="datas.institution" class="nftmax-trendmeta__content">
          <span class="nftmax-trendmeta__small">Institution</span>
          <h4 class="nftmax-trendmeta__title">
            {{ datas.institution }}
          </h4>
        </div>
        <!-- <div class="nftmax-trendmeta__author">
          <div class="nftmax-trendmeta__content">
            <span class="nftmax-trendmeta__small">Last Update</span>
            <h4 class="nftmax-trendmeta__title">
              {{ format(datas.updatedAt, "mm-dd-yyyy hh:MM:ss") }}
            </h4>
          </div>
        </div> -->
      </div>
    </div>
    <!-- Trending Head -->
    <div class="trending-action__head">
      <div v-if="datas.isActive" class="trending-action__badge">
        <span>Active</span>
      </div>
      <!-- <div :id="`lottie_box_${datas.id}`" class="lottie"></div> -->
      <div style="width: 170px; height: 100px; margin: 25px auto 0">
        <img
          v-if="datas.type === 0"
          :src="require(`@/assets/img/gene-pic.png`)"
          alt="#"
          style="width: 100%; height: 100%; object-fit: contain"
        />
        <img
          v-if="datas.type === 1"
          :src="require(`@/assets/img/ehr-pic.png`)"
          alt="#"
          style="width: 100%; height: 100%; object-fit: contain"
        />
        <img
          v-if="datas.type === 2"
          :src="require(`@/assets/img/medical-pic.png`)"
          alt="#"
          style="width: 100%; height: 100%; object-fit: contain"
        />
        <img
          v-if="datas.type === 3"
          :src="require(`@/assets/img/statistic-pic.png`)"
          alt="#"
          style="width: 100%; height: 100%; object-fit: contain"
        />
        <img
          v-if="datas.type === 4"
          :src="require(`@/assets/img/model-pic.png`)"
          alt="#"
          style="width: 100%; height: 100%; object-fit: contain"
        />
        <img
          v-if="datas.type === 5"
          :src="require(`@/assets/img/statistic-pic.png`)"
          alt="#"
          style="width: 100%; height: 100%; object-fit: contain"
        />
      </div>
    </div>
    <!-- Trending Body -->
    <div class="trending-action__body trending-marketplace__body">
      <!-- <h2 class="trending-action__title text-capitalize">
        <router-link to="/marketplace-details">{{ datas.id }}</router-link>
      </h2> -->
      <div class="nftmax-currency">
        <div class="nftmax-currency__main">
          <!-- <div class="nftmax-currency__icon">
            <img src="../../../assets/img/eth-icon.png" alt="#" />
          </div> -->
          <div class="nftmax-currency__content" style="width: 100%">
            <h4 class="nftmax-currency__content-title">
              {{ datas.subType }}
              <!-- {{
                ifShowDetails
                  ? `${$store.state.userInfo.username}-${translateType(
                      datas.type
                    )}-${datas.id}`
                  : `${translateType(datas.type)}-${datas.id}`
              }} -->
            </h4>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin: 10px 0;
              "
            >
              <el-tag size="mini" style="font-size: 14px">{{
                translateType(datas.type)
              }}</el-tag>
              <el-button
                v-if="!isAiAssistEnabled && datas.paid !== null"
                :disabled="datas.paid === true"
                type="primary"
                size="small"
                @click="claimReward(datas)"
              >
                {{ datas.paid === true ? "Reward Claimed" : "Claim Reward" }}
                <i class="el-icon-present el-icon--right"></i>
              </el-button>
            </div>
            <p
              class="nftmax-currency__content-sub"
              style="display: flex; justify-content: space-between"
            >
              <el-link
                :underline="false"
                type="danger"
                style="margin-right: 10px"
                @click="removeData(datas)"
                >Forgot encryption phrase?
              </el-link>
              <el-button
                type="primary"
                size="small"
                @click="getDetail(datas)"
                >{{
                  isAiAssistEnabled ? "Select Data" : "View Data"
                }}</el-button
              >
            </p>
          </div>
          <!-- <div v-if="datas.type !== 4" class="nftmax-currency__content">
            <el-button type="primary" size="small" @click="getDetail(datas)"
              >Details</el-button
            >
          </div> -->
        </div>
      </div>
    </div>
    <el-dialog
      v-if="detailsDialog"
      title="Data Details"
      :visible.sync="detailsDialog"
      width="80%"
      center
    >
      <el-tabs tab-position="left">
        <el-tab-pane
          v-if="selectedData.basicInfo.type !== 1"
          label="Basic Info"
        >
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>Basic Info</span>
            </div>
            <el-descriptions
              border
              :column="2"
              label-class-name="table-label-title"
            >
              <el-descriptions-item label="File ID">{{
                selectedData.basicInfo.id
              }}</el-descriptions-item>
              <el-descriptions-item label="File Name">{{
                selectedData.basicInfo.filename
              }}</el-descriptions-item>
              <el-descriptions-item label="Description">
                <el-tag size="small">{{
                  selectedData.basicInfo.subType
                }}</el-tag></el-descriptions-item
              >
              <el-descriptions-item label="Created">
                <el-tag size="small">{{
                  format(selectedData.basicInfo.createdAt, "mm-dd-yyyy")
                }}</el-tag>
              </el-descriptions-item>
              <!-- <el-descriptions-item label="Last Update">
            <el-tag size="small">{{
              format(selectedData.basicInfo.updatedAt, "mm-dd-yyyy hh:MM:ss")
            }}</el-tag></el-descriptions-item
          > -->
            </el-descriptions>
          </el-card>
        </el-tab-pane>
        <el-tab-pane
          v-if="
            selectedData.basicInfo.type === 0 ||
            selectedData.basicInfo.type === 4
          "
          label="Txt File"
        >
          <el-descriptions title="Txt File" :column="1" :colon="false">
            <el-descriptions-item>
              <pre v-if="ifShowDetails">{{ selectedData.details }}</pre>
              <pre v-else>{{ mosaicText }}</pre>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <template v-if="selectedData.basicInfo.type === 1">
          <MedicalInfoAccordion :data="selectedData.details" />
        </template>
        <el-tab-pane
          v-if="selectedData.basicInfo.type === 2"
          label="Medical Image"
        >
          <el-descriptions title="Medical Image" :column="1" :colon="false">
            <template v-if="ifShowDetails">
              <el-descriptions-item v-if="ifZipFile">
                <div class="zip-img-container">
                  <el-image
                    v-for="url in zipFilesUrlList"
                    :key="url.name"
                    :src="url.src"
                    alt="Medical Image"
                    class="zip-img"
                    lazy
                  ></el-image>
                </div>
              </el-descriptions-item>
              <el-descriptions-item v-else>
                <img
                  :src="selectedData.details"
                  alt="Medical Image"
                  class="img"
                />
              </el-descriptions-item>
            </template>
            <template v-else>
              <el-descriptions-item>
                {{ mosaicText }}
              </el-descriptions-item>
            </template>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane
          v-if="selectedData.basicInfo.type === 3"
          label="Medical Statistics"
        >
          <el-descriptions
            title="Medical Statistics"
            :column="1"
            :colon="false"
          >
            <template v-if="ifShowDetails">
              <el-descriptions-item>
                <el-table
                  :data="selectedData.details.list"
                  style="width: 100px; overflow: scroll"
                  max-height="400px"
                >
                  <el-table-column
                    v-for="title in selectedData.details.titles"
                    :key="title"
                    :prop="title"
                    :label="title"
                    fixed
                  />
                </el-table>
              </el-descriptions-item>
            </template>
            <template v-else>
              <el-descriptions-item>
                {{ mosaicText }}
              </el-descriptions-item>
            </template>
          </el-descriptions></el-tab-pane
        >
      </el-tabs>
      <br />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailsDialog = false"
          >Close</el-button
        >
      </span>
    </el-dialog>
    <!-- 输入加密口令和邮箱验证码 -->
    <el-dialog
      title="Enter encryption phrase"
      :visible.sync="verifyFormDialog"
      width="60%"
    >
      <el-form
        ref="verifyForm"
        :model="verifyForm"
        :rules="verifyFormRules"
        label-width="200px"
      >
        <el-form-item
          id="view-data-driver-step-0"
          label="Encryption Phrase"
          prop="phrase"
        >
          <el-input
            v-model="verifyForm.phrase"
            placeholder="Please enter your encryption phrase"
            type="password"
            show-password
          >
            <template #append>
              <el-tooltip
                class="box-item"
                effect="dark"
                content="Please enter your encryption phrase. Be aware that if you lose this
        phrase, you will permanently lose access to your data on our website and
        will need to transfer your data again."
                placement="top-start"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="Email Address" prop="emailAddress">
          <el-input
            v-model="verifyForm.emailAddress"
            placeholder="Please enter email address"
          >
            <el-button slot="append" @click="sendCode">Send code</el-button>
          </el-input>
        </el-form-item> -->
        <!-- <el-form-item
          id="view-data-driver-step-1"
          label="Email Verification Code"
          prop="verificationCode"
        >
          <div class="form-inline">
            <el-input
              v-model="verifyForm.verificationCode"
              placeholder="Please enter email verification code"
            >
            </el-input>
            <el-button
              type="primary"
              :disabled="sendCodeDisabled"
              @click="clickSendBtn"
              >{{ ifResend ? "Resend code" : "Send code" }}
              {{ sendCodeTimer ? `(${sendCodeTimer}s)` : "" }}</el-button
            >
          </div>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="verifyFormDialog = false">Cancel</el-button>
        <el-button type="primary" @click="submitVerifyForm">Submit</el-button>
      </span>
    </el-dialog>
    <!-- 引导视频弹窗 -->
    <el-dialog
      title="Please watch this short video before proceeding"
      :visible.sync="tourDialogVisible"
      width="70%"
      :before-close="handleTourDialogClose"
      center
    >
      <div class="tour-video">
        <video
          id="dataTourVideo"
          ref="dataTourVideo"
          controls
          width="800"
          height="480"
        >
          <source src="/video/data-tour.mp4" type="video/mp4" />
          Your browser does not support the HTML5 video tag.
        </video>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleTourDialogClose"
          >Close</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../../http/api";
import { format } from "../../../lib/time";
import JSZip from "jszip";
import Tiff from "tiff.js";
import CryptoJS from "crypto-js";
import { Loading } from "element-ui";
import handleMetaData from "@/lib/dataProcess";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import MedicalInfoAccordion from "./MedicalInfoAccordion.vue";
import detectEthereumProvider from "@metamask/detect-provider";

export default {
  components: { MedicalInfoAccordion },
  props: ["datas", "ifShowDetails", "aiAssistSelectingData"],
  data() {
    return {
      selectedData: {},
      detailsDialog: false,
      mosaicText: "■■■■■■■■",
      zipFilesUrlList: [],
      verifyFormDialog: false,
      verifyForm: {
        verificationCode: "",
        phrase: "",
        emailAddress: "",
      },
      verifyFormRules: {
        phrase: [
          {
            required: true,
            message: "Please enter encryption phrase ",
            trigger: "blur",
          },
        ],
        // verificationCode: [
        //   {
        //     required: true,
        //     message: "Please enter email verification code",
        //     trigger: "change",
        //   },
        // ],
        // emailAddress: [
        //   {
        //     required: true,
        //     message: "Please enter email address",
        //     trigger: "change",
        //   },
        // ],
      },
      encryptedData: "",
      originalJson: {},
      // 引导视频
      tourDialogVisible: false,
      sendCodeDisabled: false,
      sendCodeTimer: 0,
      sendCodeInterval: null,
      ifResend: false,
    };
  },
  computed: {
    isAiAssistEnabled() {
      return this.aiAssistSelectingData;
    },
    ifZipFile() {
      if (
        this.selectedData.basicInfo &&
        this.selectedData.basicInfo.filename.includes(".zip")
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      const lottieFile =
        this.datas.type === 0
          ? require(`@/assets/lottie/dna.json`)
          : this.datas.type === 1
          ? require(`@/assets/lottie/health.json`)
          : this.datas.type === 2
          ? require(`@/assets/lottie/medical.json`)
          : this.datas.type === 3
          ? require(`@/assets/lottie/statistic.json`)
          : require(`@/assets/lottie/model.json`);
      this.$lottie.loadAnimation({
        container: document.getElementById(`lottie_box_${this.datas.id}`), // 包含动画的dom元素
        renderer: "svg", // 渲染出来的是什么格式
        loop: true, // 循环播放
        autoplay: true, // 自动播放
        animationData: lottieFile, // 动画json的本地路径
        // path:''//网络json地址, 选择 animationData 后，则不用path了，
      });
    });
  },
  methods: {
    clickViewData() {
      if (!sessionStorage.getItem("finishFirstViewData")) {
        sessionStorage.setItem("finishFirstViewData", true);
        this.$vToastify
          .prompt({
            title: "",
            body: "Start tour guide for data upload?",
            canTimeout: true,
            duration: 3000,
          })
          .then((value) => {
            if (value) {
              this.tourDialogVisible = true;
            }
          });
      }
    },
    startTour() {
      const driverObj = driver({
        showProgress: true,
        overlayOpacity: 0.4,
        steps: [
          {
            element: "#view-data-driver-step-0",
            popover: {
              title: "Encryption Phrase",
              description:
                "Enter the encryption phrase that you had chosen when you connected to your provider. Your data is always encrypted and only you can access it with the encryption phrase. If you don’t remember your Encryption Phrase you need to connect your provider again through My Data section",
            },
          },
          {
            element: "#view-data-driver-step-1",
            popover: {
              title: "Email Verification Code",
              description:
                "The Verification Code is sent to the email associated with your Lavita account",
            },
          },
        ],
      });
      driverObj.drive();
    },
    handleTourDialogClose() {
      this.tourDialogVisible = false;
      this.startTour();
    },
    base64ToArrayBuffer(base64) {
      const binaryString = window.atob(base64);
      const length = binaryString.length;
      const arrayBuffer = new ArrayBuffer(length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }

      return arrayBuffer;
    },
    translateType(type) {
      switch (type) {
        case 0: {
          return "Genetic Data";
        }
        case 1: {
          return "EHR Data";
        }
        case 2: {
          return "Medical Image Data";
        }
        case 3: {
          return "Medical Statistics Data";
        }
        case 4: {
          return "Training Models";
        }
        case 5: {
          return "PDF Data";
        }
      }
    },
    format: format,
    // 解码 base64 数据URL 的工具函数
    decodeBase64DataUrl(dataUrl) {
      try {
        // 提取 base64 部分
        const base64Content = dataUrl.split(",")[1];

        // 使用 Buffer 解码 base64
        const decodedContent = Buffer.from(base64Content, "base64").toString(
          "utf8"
        );
        return decodedContent;
      } catch (error) {
        console.error("Error decoding base64:", error);
        throw error;
      }
    },
    // 把23andme文本数据转换为array
    convertToObjectArray(rawData) {
      // 首先按换行符分割数据为行
      const lines = rawData.trim().split("\n");

      // 获取表头（第一行），并清理空格
      const headers = lines[0]
        .replace("#", "") // 移除可能存在的#号
        .trim()
        .split(/\s+/); // 用空格分割

      // 处理数据行
      const result = lines
        .slice(1) // 跳过表头行
        .filter((line) => line.trim()) // 过滤空行
        .map((line) => {
          // 将每行按空格分割
          const values = line.trim().split(/\s+/);

          // 创建对象，将表头和值对应
          const obj = {};
          headers.forEach((header, index) => {
            obj[header] = values[index];
          });

          return obj;
        });

      return result;
    },
    async getDetail(datas) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)",
      });
      try {
        this.selectedData = {};
        const res = await api.getDataDetail({
          userId: this.$store.state.userInfo.userId,
          filename: datas.filename,
          type: datas.type,
        });
        console.log(res);
        this.selectedData = {
          basicInfo: datas,
          details: null,
        };
        this.encryptedData = res.data;
        this.verifyFormDialog = true;
      } catch (error) {
        console.log(error);
      } finally {
        loading.close();
      }
    },
    async removeData(datas) {
      this.$confirm(
        "Losing your encryption phrase results in permanent loss of access to your data on our website. This action will lead to the deletion of the inaccessible data, you may choose to re-transfer your data after the deletion.",
        "Warning",
        {
          confirmButtonText: "Delete",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(async () => {
          const loading = Loading.service({
            fullscreen: true,
            text: "loading...",
          });
          try {
            await api.invalidData({
              idList: [datas.id],
            });
            this.$alert("Deleted successfully", "", {
              confirmButtonText: "OK",
              callback: () => {
                window.location.reload();
              },
            });
          } catch (error) {
            console.log(error);
          } finally {
            loading.close();
          }
        })
        .catch(() => {});
    },
    clickSendBtn() {
      this.ifResend = true;
      this.sendCode();
    },
    async sendCode() {
      await api.sendCodeToEmail({
        email: this.$store.state.userInfo.username,
      });
      this.$vToastify.success(
        "Code has been sent to your email address, please check"
      );
      // 倒计时60s
      this.sendCodeDisabled = true;
      this.sendCodeTimer = 60;
      this.sendCodeInterval = setInterval(() => {
        if (this.sendCodeTimer > 0) {
          this.sendCodeTimer--;
        } else {
          this.sendCodeDisabled = false;
          clearInterval(this.sendCodeInterval);
        }
      }, 1000);
    },
    submitVerifyForm() {
      this.$refs.verifyForm.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "Loading...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.8)",
          });
          try {
            // await api.checkVerificationCode({
            //   username: this.$store.state.userInfo.username,
            //   userId: this.$store.state.userInfo.userId,
            //   verificationCode: this.verifyForm.verificationCode,
            // });
            // Decrypt
            const bytes = CryptoJS.AES.decrypt(
              this.encryptedData,
              this.verifyForm.phrase
            );
            const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
            if (this.isAiAssistEnabled) {
              this.$router.push({
                name: "AIAssist",
                params: {
                  decryptedData,
                  type: this.selectedData.basicInfo.type,
                  dataInfo: this.selectedData,
                },
              });
              return;
            }
            // 保存原始JSON用来展示
            // this.originalJson = details;
            // const result = handleMetaData(details);
            // this.selectedData.details = result;
            // this.verifyFormDialog = false;
            // this.detailsDialog = true;
            switch (this.selectedData.basicInfo.type) {
              case 0: {
                const decodedData = this.decodeBase64DataUrl(decryptedData);
                const result = this.convertToObjectArray(decodedData);
                this.selectedData.details = result;
                this.detailsDialog = true;
                break;
              }
              case 1: {
                this.encryptedData = decryptedData;
                const ehrData = handleMetaData(JSON.parse(decryptedData));
                console.log(ehrData);
                this.selectedData.details = ehrData;
                this.detailsDialog = true;
                break;
              }
              case 2: {
                this.selectedData.details = decryptedData;
                this.detailsDialog = true;
                break;
              }
              case 5: {
                // 将 Base64 解码为二进制数据
                const byteCharacters = atob(decryptedData);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                // 创建 Blob 对象
                const blob = new Blob([byteArray], { type: "application/pdf" });

                // 生成可访问的 URL
                const blobUrl = URL.createObjectURL(blob);

                // 打开新窗口查看 PDF
                window.open(blobUrl, "_blank");
                break;
              }
            }
            this.verifyFormDialog = false;
          } catch (error) {
            this.$vToastify.error("Decryption failed, please try again");
            console.log(error);
          } finally {
            loading.close();
          }
        }
      });
    },
    claimReward(datas) {
      this.$confirm(
        "Reward will be transferred to your current wallet address in MetaMask, continue?",
        "Reminder",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(async () => {
          const loading = this.$loading({
            lock: true,
            text: "Claiming reward, Please wait…",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.8)",
          });
          try {
            if (typeof window.ethereum === "undefined") {
              this.$alert(
                "MetaMask is not installed or connected, please check"
              );
              loading.close();
              return;
            }
            // 绑定用户钱包
            const provider = await detectEthereumProvider();
            const accounts = await provider.request({
              method: "eth_requestAccounts",
            });
            let toAddress = "";
            if (accounts.length > 0) {
              toAddress = window.ethereum.selectedAddress;
            }
            await api.registerWallet({
              userId: this.$store.state.userInfo.userId,
              address: toAddress,
            });
            await api.claimReward({
              userId: this.$store.state.userInfo.userId,
              code: datas.code,
            });
            this.$alert(
              "Reward claimed successfully! It may take a few minutes to reflect in your wallet.",
              "Congratulations!",
              {
                confirmButtonText: "OK",
                type: "success",
                callback: () => {
                  window.location.reload();
                },
              }
            );
          } catch (err) {
            this.$vToastify.error("Claim reward failed, please try again");
            console.log(err);
          } finally {
            loading.close();
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
.table-label-title {
  width: 120px;
}
</style>
<style lang="less" scoped>
::v-deep .el-tabs__item {
  margin-right: 10px;
  font-size: 16px;
  font-weight: bold;
}
::v-deep .el-tabs__item.is-active {
  background: #eeeefa 0% 0% no-repeat padding-box;
  border-radius: 10px;
}
.lottie {
  width: 200px;
  height: 200px;
  margin: auto;
}
.img {
  width: 200px;
  height: 200px;
}
.box-card {
  margin: 20px;
}
.zip-img-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 三列等宽 */
  grid-gap: 30px;
}
.zip-img {
  width: 100%; /* 图片宽度占满列 */
  height: auto; /* 高度自适应，保持正方形 */
  max-width: 100%; /* 最大宽度100% */
}
.table-cell {
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
}
.epic-data-table {
  width: 100%;
  height: 400px;
  overflow-x: scroll;
  overflow-y: scroll;
  ::v-deep .epic-data-table-header {
    color: #34e393;
    font-weight: bold;
    font-size: 16px;
  }
  ::v-deep .el-table .el-table__body-wrapper {
    overflow-x: scroll;
  }

  ::v-deep .el-table .el-table__body {
    overflow-y: hidden;
  }
}
::v-deep .el-table .el-table__body-wrapper {
  overflow-x: scroll;
}

::v-deep .el-table .el-table__body {
  overflow-y: hidden;
}
.tour-video {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.form-inline {
  display: flex;
  align-items: center;
}
.form-inline .el-button {
  margin-left: 30px;
}
</style>
